/**
 * Node Modules
 */
import React from 'react'
import { Link } from 'gatsby'

/**
 * Application Modules
 */
import './style.css'
import GDPRBanner from '../../gdpr'

/**
 * Component
 */
export default function Footer({ style }) {
  return (
    <>
    <footer style={style} className="footer">
      <div className="footer__grid grid">
        <div className="footer__kidsafe column-start-1--t column-end-6--t">
          <a
            href="http://www.kidsafeseal.com/certifiedproducts/kinzoo_app.html"
            rel="noopener"
            target="_blank"
          >
            <img
              border="0"
              alt="Kinzoo (mobile app) is certified by the kidSAFE Seal Program."
              src="/kidSAFE-COPPA.png"
              className="footer__kidsafe-image"
            />
          </a>
          <img
              border="0"
              alt="Mom's Choice Awards Honoring Excellence"
              src="/MCA_Logo_Gold.png"
              className="footer__mca-image"
            />
        </div>
        <ul className="footer__social-media column-start-7--t column-end-12--t">
          <li className="footer__social-item">
            <a
              className="footer__social-link footer__social-link--twitter"
              href="https://twitter.com/kinzoomessenger"
              target="_blank"
              rel="noopener noreferrer"
            >
              Twitter
            </a>
          </li>
          <li className="footer__social-item">
            <a
              className="footer__social-link footer__social-link--facebook"
              href="https://www.facebook.com/kinzoomessenger/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </a>
          </li>
          <li className="footer__social-item">
            <a
              className="footer__social-link footer__social-link--instagram"
              href="https://www.instagram.com/kinzoomessenger/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
          </li>
          <li className="footer__social-item">
            <a
              className="footer__social-link footer__social-link--linkedin"
              href="https://www.linkedin.com/company/kinzoomessenger/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Linkedin
            </a>
          </li>
        </ul>

        <div className="footer__copyright column-start-1--t column-end-6--t">
          <span className="footer__copyright-symbol">&copy;</span> 2021 Kinzoo Technologies Inc.
        </div>

        <div className="footer__legal-links column-start-7--t column-end-12--t">
          <span className="footer__legal-links-subgroup">
            <Link className="footer__legal-link" to="/help-center">
              Contact Us
            </Link>
            <span className="footer__legal-seperator">|</span>
            <Link className="footer__legal-link" to="/get-involved#press">
              Press Kit
            </Link>
          </span>
          <span className="footer__legal-links-subgroup">
            <span className="footer__legal-seperator footer__legal-seperator--no-mobile">|</span>
            <Link className="footer__legal-link" to="/terms">
              Terms and Conditions
            </Link>
          </span>
          <span className="footer__legal-links-subgroup">
            <span className="footer__legal-seperator"></span>
            <Link className="footer__legal-link" to="/cookies-policy">
              Cookies Policy
            </Link>
            <span className="footer__legal-seperator">|</span>
            <Link className="footer__legal-link footer__legal-link--highlight" to="/privacy-policy">
              Privacy Policy
            </Link>

          </span>
        </div>
      </div>
    </footer>
    <GDPRBanner />
    </>
  )
}
